import type { JSX } from 'react'
import type { ICard } from '../Card'

import { InlineFontButton2ForwardButton } from 'atoms/Button/Templates'
import { COLOR } from 'vars/index'
import { CardContentContainerSC } from '../base-card'
import { Card } from '../Card'
import { CARDS_ASPECT_RATIO, CardCorners } from '../Card.h'

export interface ILoadMoreGridCardProps extends Omit<ICard, 'children'> {
  title?: string
}

export const LoadMoreGridCard = ({
  width = '100%',
  gridCard = true,
  overlayEnabled = false,
  overlayOnHoverEnabled = false,
  aspectRatio = CARDS_ASPECT_RATIO.HORIZONTAL_DEFAULT,
  corners = CardCorners.CORNERS_0,
  backgroundColor = COLOR.TEXT_ICON_CONSTANT_DARK,
  backgroundColorHovered = COLOR.TEXT_ICON_CONSTANT_DARK,
  posterEnabled = false,
  onClick,
  title = 'More',
  ...rest
}: ILoadMoreGridCardProps): JSX.Element => (
  <Card
    width={width}
    gridCard={gridCard}
    overlayEnabled={overlayEnabled}
    overlayOnHoverEnabled={overlayOnHoverEnabled}
    aspectRatio={aspectRatio}
    corners={corners}
    backgroundColor={backgroundColor}
    backgroundColorHovered={backgroundColorHovered}
    onClick={onClick}
    posterEnabled={posterEnabled}
    {...rest}
  >
    <CardContentContainerSC>
      <InlineFontButton2ForwardButton title={title} />
    </CardContentContainerSC>
  </Card>
)

LoadMoreGridCard.displayName = 'LoadMoreGridCard'
